"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect, useRef } from "react";

import { regionFromPathname } from "@/lib/region";

// Nav settings (mega menus, footer, etc.) are fetched per-region in the shared
// layout, which the App Router preserves across a client-side region switch.
// Re-fetch the server tree when the region actually changes so region-specific
// content updates without a hard refresh.
export function RegionRefresh() {
  const pathname = usePathname();
  const router = useRouter();
  const region = regionFromPathname(pathname ?? "/");
  const prevRegion = useRef(region);

  useEffect(() => {
    if (prevRegion.current === region) return;
    prevRegion.current = region;
    router.refresh();
  }, [region, router]);

  return null;
}
